import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Choices from 'choices.js';
export var googleTranslate = function googleTranslate() {
  Alpine.data('googleTranslate', function () {
    return {
      translate: undefined,
      translateSelect: undefined,
      translateChoicesSelect: undefined,
      translateElement: undefined,
      translateElementId: 'google_translate_element',
      init: function init() {
        this.translateElement = this.$el.querySelector("#".concat(this.translateElementId));
        this.addGoogleTranslate();
        this.translateReady();
      },
      addGoogleTranslate: function addGoogleTranslate() {
        var tag = document.createElement('script');
        var firstScriptTag = document.getElementsByTagName('script')[0];
        tag.src = '//translate.google.com/translate_a/element.js?cb=googleTranslate';
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      },
      initSelect: function initSelect() {
        this.translateSelect = this.translateElement.querySelector('select');
        var options = this.translateSelect.querySelectorAll('option');
        if (options.length === 0) {
          window.requestAnimationFrame(this.initSelect.bind(this));
        } else {
          this.translateChoicesSelect = new Choices(this.translateSelect, {});
          // Add accessibility aria attributes.
          var list = this.translateChoicesSelect.itemList.element;
          list.setAttribute('role', 'listbox');
          var item = list.querySelector('.choices__item');
          item.setAttribute('role', 'option');
        }
      },
      translateReady: function translateReady() {
        var _this = this;
        this.translate = typeof google !== 'undefined' && google.translate;
        if (!this.translate) {
          window.requestAnimationFrame(this.translateReady.bind(this));
        } else {
          window.googleTranslate = function () {
            var initTranslate = new _this.translate.TranslateElement({
              pageLanguage: 'en'
            }, _this.translateElementId);
            _this.initSelect();
          };
        }
      }
    };
  });
};